<template>
    <div class="sensitive-word-page">
        <div class="toolbar">
            <el-input
                    v-model="keyword"
                    class="keyword-input"
                    placeholder="请输入关键词"
                    :disabled="saving"
                    @keyup.enter.native="getList"/>
            <el-button type="primary" :disabled="saving" @click="getList">查询</el-button>
            <el-button class="add-button" type="primary" :disabled="saving" @click="addWord">新增</el-button>
            <span class="column-label">每行显示</span>
            <el-select v-model="columnCount" class="column-select" :disabled="saving">
                <el-option
                        v-for="option in 8"
                        :key="option"
                        :label="option"
                        :value="option"/>
            </el-select>
            <span>个</span>
        </div>

        <div class="common-table">
            <el-table
                    v-loading="loading"
                    :data="rows"
                    :show-header="false"
                    border>
                <el-table-column
                        v-for="(column, columnIndex) in columnCount"
                        :key="column"
                        align="center">
                    <template slot-scope="scope">
                        <div
                                v-if="scope.row[columnIndex] !== undefined"
                                class="word-cell"
                                @click="startEdit(scope.$index * columnCount + columnIndex)">
                            <el-input
                                    v-if="editingIndex === scope.$index * columnCount + columnIndex"
                                    ref="editInput"
                                    v-model="editValue"
                                    :disabled="saving"
                                    @click.native.stop
                                    @keyup.enter.native="saveEdit"
                                    @blur="saveEdit"/>
                            <template v-else>
                                <span>{{scope.row[columnIndex]}}</span>
                                <el-button
                                        v-if="editingIndex === null"
                                        class="delete-button"
                                        type="text"
                                        icon="el-icon-delete"
                                        title="删除"
                                        aria-label="删除敏感词"
                                        @click.stop="deleteWord(scope.$index * columnCount + columnIndex)"/>
                            </template>
                        </div>
                    </template>
                </el-table-column>
            </el-table>
        </div>
    </div>
</template>

<script>
    import api from '../../../store/api'

    export default {
        data() {
            return {
                keyword: '',
                columnCount: 4,
                words: [],
                loading: false,
                editingIndex: null,
                editValue: '',
                oldValue: '',
                saving: false
            }
        },
        computed: {
            rows() {
                let rows = [];
                for (let index = 0; index < this.words.length; index += this.columnCount) {
                    rows.push(this.words.slice(index, index + this.columnCount))
                }
                return rows
            }
        },
        created() {
            this.getList()
        },
        methods: {
            cleanValue(value) {
                return String(value == null ? '' : value).replace(/\s/g, '')
            },
            getList() {
                if (this.saving) {
                    return Promise.resolve()
                }
                this.loading = true;
                return api.post('/sensitive/word/list', '查询敏感词', {
                    keyword: this.keyword
                }).then(res => {
                    this.words = Array.isArray(res.data) ? res.data : []
                }).catch(() => {
                }).then(() => {
                    this.loading = false
                })
            },
            addWord() {
                if (this.saving) {
                    return Promise.resolve()
                }
                this.saving = true;
                let cleanedValue = '';
                return this.$prompt('请输入敏感词', '新增敏感词', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    inputValue: null,
                    inputValidator: value => {
                        cleanedValue = this.cleanValue(value);
                        return cleanedValue ? true : '敏感词不能为空'
                    }
                }).then(() => {
                    return api.post('/sensitive/word/add', '新增敏感词', {
                        value: cleanedValue
                    }).then(res => {
                        if (res.code === 0) {
                            if (this.words.indexOf(res.data) === -1) {
                                this.words.push(res.data)
                            }
                            this.$message.success('新增成功')
                        }
                    })
                }).catch(() => {
                }).then(() => {
                    this.saving = false
                })
            },
            deleteWord(index) {
                if (this.saving || this.words[index] === undefined) {
                    return Promise.resolve()
                }
                const value = this.words[index];
                this.saving = true;
                return this.$confirm(`确定删除敏感词“${value}”吗？`, '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(() => {
                    return api.post('/sensitive/word/delete', '删除敏感词', {value})
                }).then(res => {
                    if (res.code === 0) {
                        this.words.splice(index, 1);
                        this.$message.success('删除成功')
                    }
                }).catch(() => {
                }).then(() => {
                    this.saving = false
                })
            },
            startEdit(index) {
                if (this.saving || this.editingIndex === index) {
                    return
                }
                this.editingIndex = index;
                this.oldValue = this.words[index];
                this.editValue = this.oldValue;
                this.$nextTick(() => {
                    let input = this.$refs.editInput;
                    if (Array.isArray(input)) {
                        input = input[0]
                    }
                    if (input) {
                        input.focus()
                    }
                })
            },
            saveEdit() {
                if (this.editingIndex === null || this.saving) {
                    return
                }
                const index = this.editingIndex;
                const oldValue = this.oldValue;
                const newValue = this.cleanValue(this.editValue);
                if (!newValue) {
                    this.$message.error('敏感词不能为空');
                    this.finishEdit();
                    return
                }
                if (newValue === oldValue) {
                    this.finishEdit();
                    return
                }
                this.saving = true;
                return api.post('/sensitive/word/edit', '编辑敏感词', {
                    oldValue,
                    newValue
                }).then(res => {
                    this.$set(this.words, index, res.data);
                    this.$message.success('修改成功')
                }).catch(() => {
                    this.$set(this.words, index, oldValue)
                }).then(() => {
                    this.finishEdit()
                })
            },
            finishEdit() {
                this.editingIndex = null;
                this.editValue = '';
                this.oldValue = '';
                this.saving = false
            }
        }
    }
</script>

<style lang="scss" scoped>
    .toolbar {
        display: flex;
        align-items: center;
        margin-bottom: 20px;
    }

    .keyword-input {
        width: 260px;
        margin-right: 10px;
    }

    .add-button {
        margin-left: 10px;
    }

    .column-label {
        margin-left: 30px;
        margin-right: 10px;
    }

    .column-select {
        width: 90px;
        margin-right: 10px;
    }

    .word-cell {
        position: relative;
        min-height: 40px;
        line-height: 40px;
        cursor: pointer;
    }

    .delete-button {
        position: absolute;
        right: 6px;
        top: 0;
    }

    .word-cell :global(.el-input__inner) {
        text-align: center;
    }
</style>
